export const isStringMatch = (searchValue: string, dataValue: string): boolean =>
	dataValue?.toLowerCase().includes(searchValue?.toLowerCase()) ?? false;
